import React from 'react';
import SearchInputField from '../../Forms/Input/SearchInputField';
import SelectField from '../../Forms/Input/SelectField';
import Checkbox from '../../Forms/Input/Checkbox';

interface Option {
  id: number;
  name: string;
}

interface Props {
  branches: Option[];
  categories: Option[];

  branchId: number | null;
  term: string;
  categoryId: number | null;
  onlyNegative: boolean;

  onChangeBranch: (branchId: number | null) => void;
  onChangeTerm: (term: string) => void;
  onChangeCategory: (categoryId: number | null) => void;
  onChangeOnlyNegative: (value: boolean) => void;
}

const InitialStockAdminFilters: React.FC<Props> = ({
  branches,
  categories,
  branchId,
  term,
  categoryId,
  onlyNegative,
  onChangeBranch,
  onChangeTerm,
  onChangeCategory,
  onChangeOnlyNegative,
}) => {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
      <SelectField
        label="Sucursal"
        name="branchId"
        value={branchId ?? ''}
        onChange={(e) => {
          const value = e.target.value;
          onChangeBranch(value === '' ? null : Number(value));
        }}
        options={[
          { value: '', label: 'Todas las sucursales' },
          ...branches.map((b) => ({ value: b.id, label: b.name })),
        ]}
        placeholder="Todas las sucursales"
      />

      <div className="md:col-span-2">
        <SearchInputField
          label="Buscar"
          name="term"
          value={term}
          onChange={(e) => onChangeTerm(e.target.value)}
          placeholder="Nombre, código, SKU o código de barras..."
        />
      </div>

      <SelectField
        label="Categoría"
        name="categoryId"
        value={categoryId ?? ''}
        onChange={(e) => {
          const value = e.target.value;
          onChangeCategory(value === '' ? null : Number(value));
        }}
        options={[
          { value: '', label: 'Todas las categorías' },
          ...categories.map((c) => ({ value: c.id, label: c.name })),
        ]}
        placeholder="Todas las categorías"
      />

      <div className="md:col-span-4">
        <Checkbox
          label="Mostrar solo productos con stock negativo"
          checked={onlyNegative}
          onChange={() => onChangeOnlyNegative(!onlyNegative)}
        />
      </div>
    </div>
  );
};

export default InitialStockAdminFilters;
